module.exports = __webpack_public_path__ + "static/media/secondaryconslogo.e05bae1b.svg";